const ComponentsLookup = {
  "default-footer": "DefaultFooterBba0b90268564770A0cfC2b4a26af156"
}

export default ComponentsLookup;